<template style="width: 50%">
  <el-form ref="form" :rules="pwdRules" :model="form" label-width="100px" >
    <el-form-item label="输入旧密码" prop="oldPassword">
      <el-input v-model="form.oldPassword" show-password></el-input>
    </el-form-item>
    <el-form-item label="输入新密码" prop="newPassword">
      <el-input v-model="form.newPassword" show-password></el-input>
    </el-form-item>
    <el-form-item label="再次输入密码" prop="comfirePassword">
      <el-input v-model="form.comfirePassword" show-password></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import {uPassword} from "@/api/userApi";
import {removeToken} from "@/utils/auth";
import {mapActions} from "vuex";

export default {
  data() {
    // 账号的校验方法
    let validateoldPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入旧密码"));
      }
      return callback();
    };

    // 账号的校验方法
    let validatenewPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入新密码"));
      }
      return callback();
    };

    // 再次输入新密码
    let validateComfirePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请再次输入密码"));
      }
      return callback();
    };

    return {
      form: {
        oldPassword:'',
        newPassword: '',
        comfirePassword: ''
      },
      pwdRules:{
        oldPassword:[{
          validator: validateoldPassword,
          trigger: "blur"
        }],
        newPassword:[
          {
            validator: validatenewPassword,
            trigger: "blur"
          }
        ],
        comfirePassword:[
          {
            validator: validateComfirePassword,
            trigger: "blur"
          }
        ]
      }
    }
  },
  methods :{
    ...mapActions(["setUser", "setShowLogin"]),
    onSubmit(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 表单校验通过，提交表单

          // 比较两次密码
          if (this.form.newPassword !== this.form.comfirePassword) {
            this.$message({
              message: "两次密码输入不一致",
              type: 'error'
            })
            return
          }
          // 提交表单
          uPassword(this.form).then(res =>{
            this.$message({
              message: res.msg,
              type: 'success',
            })
            // 清空本地登录信息
            localStorage.setItem("user", "");
            // 清空vuex登录信息
            this.setUser("");
            removeToken("")
           // 重新登录
            this.setShowLogin(true)
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.el-color-picker__icon, .el-input, .el-textarea{
  width: 50% !important;
}
.el-form .el-form-item__content .el-input .el-input__inner {
  width: 50% !important;
}
</style>